import UnderstandSectionUseCase from "@domains/useCases/Reports/UnderstandingSection/UnderstandingSection";
import UnderstandSectionRepository from "@adapters/repositories/Reports/UnderstandingSection";
import { accountDetails, http } from "@di";
export default () => {
    return {
        understandingSection: new UnderstandSectionUseCase(new UnderstandSectionRepository(http, accountDetails)),
    };
};
